/**
 * Scripts spécifiques à la page About Us
 */
// Importer les javascripts généraux
import "./main";
// importer le code des modals des profils
import ModalProfil from "./modules/modal_profil";
//importer les modules nécessaires
import MediaQuery from "./modules/media_query";
// Importer Swiper JS
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
// Importer Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
// Caroussel "flip cards" de la page about us
const mediaQuery = new MediaQuery(3); // Init l'objet qui permet de déterminer la taille de l'écran; afficher 3 cartes (desktop)
// init Swiper:
const swiperCards = new Swiper('#carrousel-flip-cards-about', {
    // configure Swiper to use modules
    modules: [Navigation],
    // Optional parameters
    loop: true,
    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    slidesPerView: mediaQuery.handleScreenChange(),
});
// Animer les cartes "onclick"
var cartes = document.querySelectorAll('.flip-card__wrapper');
[...cartes].forEach((carte) => {
    carte.addEventListener('click', function (ev) {
        // Empêcher le retournement de la carte lorsqu'on clique sur le CTA
        const cta = carte.querySelector('a.diapo-carte__cta');
        if (cta == ev.target) {
            return;
        }
        // Appliquer le style qui fait tourner la carte
        carte.classList.toggle('flip-card__wrapper--is-flipped');
    });
});
// Init des modals
new ModalProfil();
